import { fonts } from "../../assets/fonts/font";
import colorConfigs from "../../configs/colorConfigs";

export const profileStyles = {
  container: {
    mt: 2,
    alignItems: { xs: 'flex-start', sm: 'center' },
    textAlign: { xs: 'left', sm: 'center' },
    width: '100%',
    p: {
      xs: 1,
      sm: 3
    },
    maxWidth: { sm: '500px', xs: '400px' },
    mx: { sm: 'auto', xs: 'auto' },
  },
  title: {
    fontWeight: "bold",
    mb: 0,
  },
  totalBalance: {
    fontWeight: "bold",
  },
  balanceAmount: {
    color: colorConfigs.tertiary,
    mt: 1,
    fontSize: "18px",
    fontWeight: "bold",
  },
  balanceNotAvailable: {
    fontWeight: "bold",
  },
  qrCodeBox: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    borderRadius: "18px",
    border: `2px solid ${colorConfigs.tertiary}`,
    width: "fit-content",
    overflow: "hidden",
    margin: "auto"
  },
  qrCodeCaption: {
    mt: 7,
    mb: 2,
    color: colorConfigs.tertiary,
    textAlign: "center",
  },
  qrOverlayBox: (size: number, isMobile: boolean) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: size,
    height: size,
    backgroundColor: 'var(--color-overlay-white-70)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '3%',
    zIndex: 1,
  }),
  refreshButton: (size: number) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: size * 0.9,
    height: size * 0.9,
    padding: 0,
    backgroundColor: 'var(--color-overlay-black-80)',
    '&:hover': {
      backgroundColor: 'var(--color-overlay-black-70)',
    },
  }),
  refreshIcon: (isMobile: boolean) => ({
    mb: 1,
    fontSize: isMobile ? 55 : 70,
    color: colorConfigs.white,
  }),
  topUpButton: {
    mt: 2,
    width: "100%",
    backgroundColor: colorConfigs.primary,
    color: colorConfigs.secondary,
    textTransform: "none",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "30px",
    py: 1.5,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
  },
  linkCardButton: {
    mt: 2,
    width: "100%",
    backgroundColor: colorConfigs.tertiary,
    color: colorConfigs.secondary,
    textTransform: "none",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "30px",
    py: 1.5,
    '&:hover': {
      backgroundColor: colorConfigs.tertiary,
    },
  },
  unlockFridgeButton: {
    mb: 2,
    width: "50%",
    backgroundColor: colorConfigs.primary,
    color: colorConfigs.secondary,
    textTransform: "none",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "30px",
    py: 1.5,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
  },
  savedCardsContainer: {
    mt: 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: 3,
  },
  savedCardsTitle: {
    fontWeight: 'bold',
    mb: 2,
    textAlign: { xs: 'left', sm: 'center' },
    width: '100%',
  },
  savedCard: {
    mb: 2,
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: colorConfigs.backgrounds.card,
    borderRadius: '12px',
    boxShadow: 'none',
    width: '100%',
    maxWidth: '500px',
  },
  cardNumber: {
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'left',
  },
  cardExpiry: {
    color: 'text.secondary',
    width: '100%',
    textAlign: 'right',
  },
  settleBalanceButton: {
    width: "fit-content",
    backgroundColor: colorConfigs.primary,
    color: colorConfigs.secondary,
    textTransform: "none",
    fontSize: "16px",
    fontFamily: fonts.medium,
    fontWeight: "bold",
    borderRadius: "10px",
    py: 1.5,
    '&:hover': {
      backgroundColor: colorConfigs.primary,
    },
  },
  walletButton: {
    borderRadius: 4,
    border: `2px solid ${colorConfigs.tertiary}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: {xs:'80%',sm:'55%'},
    padding: 1,
    backgroundColor: colorConfigs.quaternary,
    cursor: "pointer",
    
  },
  linkCardButton2: {
    borderRadius: 4,
    border: `2px solid ${colorConfigs.tertiary}`,
    display: "flex",
    justifyContent: "left",
    alignItems: "left",
    width: "50%",
    padding:{xs:1, sm:1},
    backgroundColor: colorConfigs.quaternary,
    cursor: "pointer",
  },
  topupButton: {
    borderRadius: 4,
    display: "flex",
    justifyContent: "left",
    alignItems: "left",
    width: "50%",
    padding:{xs:1, sm:1},
    backgroundColor: colorConfigs.primary,
    cursor: "pointer",
  },
  buttonImage: {
    width: {
      xs: 50,
      sm: 50,
    },
    height: 'auto',
    margin: {
      xs: 1,
    },
    objectFit: "contain",
  },
  viewmenubutton:{
    backgroundColor:colorConfigs.quaternary,
    width: "80%",
    color: colorConfigs.secondary,
    BorderStyle:'solid',
    borderColor:colorConfigs.primary,
    borderRadius: 2,
    border: `2px solid ${colorConfigs.tertiary}`,
    '&:hover': {
      backgroundColor: colorConfigs.quaternary,
    },
  }
};
